<template>
    <pendo-menu
        :items="items"
        @click-item="onClickItem">
        <template #trigger="{ shown, toggle }">
            <pendo-icon-button
                :class="{ 'toolbar-menu__trigger--active': shown }"
                :disabled="!items.length"
                :icon="icon"
                :tooltip="tooltip"
                @click="toggle" />
        </template>
        <template #item="{ item }">
            <div
                class="toolbar-menu__item"
                :class="{ 'toolbar-menu__item--disabled': item.disabled }">
                <pendo-icon
                    :type="item.icon"
                    :size="14" />
                <span>{{ item.label }}</span>
            </div>
        </template>
    </pendo-menu>
</template>

<script>
import { PendoMenu, PendoIconButton, PendoIcon } from '@pendo/components';

export default {
    name: 'AskPendoToolbarMenu',
    components: {
        PendoIcon,
        PendoIconButton,
        PendoMenu,
    },
    props: {
        icon: {
            type: String,
            required: true,
        },
        items: {
            type: Array,
            default: () => [],
        },
        tooltip: {
            type: String,
            default: null,
        },
    },
    methods: {
        onClickItem (item) {
            item.onClick?.();
        },
    },
};
</script>

<style scoped lang="less">
.toolbar-menu__trigger {
    &--active {
        border-color: transparent;
        background-color: var(--palette-gray-30);
        color: var(--palette-gray-100);
    }
}

.toolbar-menu__item {
    flex-grow: 1;
    display: flex;
    align-items: center;
    gap: 8px;
    max-width: 400px;
    line-height: initial;

    span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &--disabled {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
    }
}
</style>
